module.exports = __webpack_public_path__ + "static/04-a62418e272c3aba1ee93c9223f878e89.jpg";